export const SHOPPING_AIDS_ITEM = [
  {
    item: 'Simone',
    itemImageDesktop: '/images/packaging/shoppingAids/desktop/jewelryTrays.webp',
    itemImageMobile: '/images/packaging/shoppingAids/mobile/jewelryTrays.webp',
    path: '/packaging/shopping-aids/jewelryTrays/simone',
  },
]